define('store-helper-get-content',['exports', 'helper-component-setStructure'], function (exports, _helperComponentSetStructure) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _helperComponentSetStructure2 = _interopRequireDefault(_helperComponentSetStructure);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var assignComponents = function assignComponents(app, page) {

        Object.keys(page).map(function (prop) {
            if (Array.isArray(page[prop]) && Array.isArray(app[prop])) {
                page[prop] = page[prop].concat(app[prop]);
            }
        });

        var res = Object.assign({}, app, page);

        if (res.glossary) {
            delete res.glossary;
        }

        if (res.custombgimages) {
            delete res.custombgimages;
        }

        return res;
    };

    var getImageScaleSize = function getImageScaleSize(app, page) {
        switch (page) {
            case 0:
                return app === 1 ? 'contain' : 'cover';
            case 1:
                return 'cover';
            case 2:
                return 'contain';
            case 3:
                return '100% 100%';
            default:
                return 'contain';
        }
    };

    var getContent = function getContent() {
        var app = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var training = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var entity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        var content = entity.contentEntity || null;

        if (!content) {
            return null;
        }

        return {
            ID: entity.contentEntityId,
            answers: entity.answers,
            canSubmitMultipleTimes: !!content.canSubmitMultipleTimes,
            components: assignComponents(app.components, (0, _helperComponentSetStructure2.default)(training.parseComponents(content.componentsJson))),
            displayMode: content.displayMode,
            imagePosition: content.imagePosition || app.imagePosition,
            imageScaleMode: content.imageScaleMode || app.imageScaleMode,
            imageScaleSize: getImageScaleSize(app.imageScaleMode, content.imageScaleMode),
            parentID: content.parentId,
            typeID: entity.typeId,
            questions: entity.questions
        };
    };

    exports.default = getContent;
});
